import type {
  MetadataMetadataCategorySchema,
  MetadataMetadataViewSchemaWithId,
} from '@iconik-io/iconik-api/src/services/metadata';

export type CategoryName = string;

const CATEGORY_OBJECT_TYPES = [
  'assets',
  'collections',
  'segments',
  'search',
  'custom_actions',
] as const;

export type CategoryObjectType = (typeof CATEGORY_OBJECT_TYPES)[number];

const categoryObjectTypeSet: ReadonlySet<string> = new Set(
  CATEGORY_OBJECT_TYPES,
);

export const isCategoryObjectType = (
  value: string,
): value is CategoryObjectType => categoryObjectTypeSet.has(value);

export type MetadataCategoryObjectType = Exclude<
  CategoryObjectType,
  'search' | 'custom_actions'
>;

// Search and custom action categories hold no metadata to change.
export const isMetadataCategoryObjectType = (
  value: string | undefined,
): value is MetadataCategoryObjectType =>
  value !== undefined &&
  value !== 'search' &&
  value !== 'custom_actions' &&
  isCategoryObjectType(value);

export type MetadataMetadataCategorySchemaPatched = Omit<
  MetadataMetadataCategorySchema,
  'object_type' | 'views' | 'name'
> & {
  id: string;
  views?: MetadataMetadataViewSchemaWithId[];
  name: CategoryName;
  object_type: CategoryObjectType;
};

export type MetadataCategoryAppState = {
  [categoryName in CategoryName]?: MetadataMetadataCategorySchemaPatched;
};

export type MetadataCategoryViewsAppState = {
  [objectType in CategoryObjectType]: MetadataCategoryAppState;
};

export type MetadataCategoriesAppState = {
  metadataCategoryViews: MetadataCategoryViewsAppState;
  metadataTypeCategories: {
    [objectType in CategoryObjectType]?: MetadataMetadataCategorySchemaPatched[];
  };
};
